import { NgModule, LOCALE_ID } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import {
  HttpBackend, HttpClient, provideHttpClient, withInterceptorsFromDi
} from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { CookieService } from 'ngx-cookie-service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgxWebstorageModule } from 'ngx-webstorage';
import locale from '@angular/common/locales/en';
import moment from 'moment';
import { NgbDateAdapter, NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import NgbDateMomentAdapter from 'app/shared/util/datepicker-adapter';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import LoginService from 'app/account/login/login.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import BjcrxSharedModule from 'app/shared/shared.module';
import fontAwesomeIcons from './icons/font-awesome-icons';
import AccountService from './auth/account.service';
import IdleService from './auth/idle.service';
import NgbDateCustomParserFormatter from './auth/dateformat.service';
import ConfirmationDialogService from './confirmation-dialog/confirmation-dialog.service';
import ConfirmationDialogComponent from './confirmation-dialog/confirmation-dialog.component';
import AddressValidationDialogService from './address-validation-dialog/address-validation-dialog.service';
import AddressValidationDialogComponent from './address-validation-dialog/address-validation-dialog.component';
import AppConfigService from './app-config.service';

@NgModule({
  declarations: [ConfirmationDialogComponent, AddressValidationDialogComponent],
  imports: [NgxWebstorageModule.forRoot({ prefix: 'jhi', separator: '-' }),
    BjcrxSharedModule,
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (httpBackend: HttpBackend): TranslateHttpLoader => new TranslateHttpLoader(new HttpClient(httpBackend), './i18n/', '.json'),
        deps: [HttpBackend]
      },
      defaultLanguage: 'en'
    })],
  providers: [
    AppConfigService,
    CookieService,
    Title,
    {
      provide: LOCALE_ID,
      useValue: 'en'
    },
    { provide: NgbDateAdapter, useClass: NgbDateMomentAdapter },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    DatePipe,
    AccountService,
    IdleService,
    LoginService,
    ConfirmationDialogService,
    AddressValidationDialogService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export default class BjcrxCoreModule {
  constructor(iconLibrary: FaIconLibrary, private dpConfig: NgbDatepickerConfig) {
    registerLocaleData(locale);
    iconLibrary.addIconPacks(fas);
    iconLibrary.addIcons(...fontAwesomeIcons);
    this.dpConfig.minDate = { year: moment().year() - 100, month: 1, day: 1 };
    this.dpConfig.maxDate = { year: moment().year(), month: moment().month() + 1, day: moment().date() };
  }
}
